import React from 'react';
import ReactTooltip from 'react-tooltip';
import { InfoCircleIcon } from '../icons';

const InfoIcon = ({ tooltipText, css }) => {
  return (
    <div
      style={{
        display: 'inline-block',
        marginLeft: 5,
        height: 15,
        width: 15,
        ...css,
      }}
    >
      <InfoCircleIcon
        style={{
          marginRight: 5,
          height: 15,
          width: 15,
          color: '#CCC',
        }}
        data-tip={tooltipText}
      />
      <ReactTooltip
        multiline={true}
        border={true}
        className="pm-info-tooltip"
      />
    </div>
  );
};

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/components/info-tooltip-icon/info-tooltip-icon.js